import {
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
	ModalSize,
} from '@montel/montelpro-shared-components-v2';
import { FunctionComponent } from 'react';
import { styled } from 'styled-components';

interface StandardModalProps {
	isOpen: boolean;
	onClose: () => void;
	size?: ModalSize;
	header?: React.ReactNode;
	footer?: React.ReactNode;
	children: React.ReactNode;
	gap?: number;
	allowOverflow?: boolean;
	minHeightPx?: number;
}

export const StandardModal: FunctionComponent<StandardModalProps> = ({
	isOpen,
	onClose,
	header,
	children,
	footer,
	gap,
	size = 'md',
	allowOverflow = false,
	minHeightPx = 300,
}) => (
	<StyledModal
		size={size}
		isOpen={isOpen}
		onClose={onClose}
		$allowOverflow={allowOverflow}
	>
		<ModalHeader>{header}</ModalHeader>
		<StyledModalBody
			$gap={gap}
			$allowOverflow={allowOverflow}
			$minHeightPx={minHeightPx}
		>
			{children}
		</StyledModalBody>
		<ModalFooter divider>{footer}</ModalFooter>
	</StyledModal>
);

const StyledModalBody = styled(ModalBody)<{
	$gap: number | undefined;
	$allowOverflow: boolean;
	$minHeightPx: number;
}>`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: ${({ $gap }) => ($gap ? `${$gap}px` : 'unset')};
	min-height: ${({ $minHeightPx }) => `${$minHeightPx}px`};
	overflow: ${({ $allowOverflow }) => ($allowOverflow ? 'visible' : 'auto')};
`;

const StyledModal = styled(Modal)<{ $allowOverflow: boolean }>`
	section {
		overflow: ${({ $allowOverflow }) =>
			$allowOverflow ? 'visible' : 'auto'};
	}
`;
